import React from 'react'
import PropTypes from 'prop-types'
import { useSortedData } from 'src/hooks'
import Table from '../Table'

/**
 * A self sorted table
 */
const SortedTable = ({ data, ...props }) => {
  // init state
  const [{ sortBy, sortDirection, sortWith }, sort] = React.useState({})

  // sort data
  const sorted = useSortedData({ data, sortBy, sortDirection, sortWith })

  // render table
  return <Table sort={sort} sortBy={sortBy} sortDirection={sortDirection} data={sorted} {...props} />
}

SortedTable.propTypes = {
  data: PropTypes.array,
}

export default React.memo(SortedTable)
